import { render, staticRenderFns } from "./KsVuetablePagination.vue?vue&type=template&id=f465bb28"
import script from "./KsVuetablePagination.vue?vue&type=script&lang=js"
export * from "./KsVuetablePagination.vue?vue&type=script&lang=js"
import style0 from "./KsVuetablePagination.vue?vue&type=style&index=0&id=f465bb28&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports